import React, { Component } from 'react'
import { connect } from 'react-redux'

import '../../../assets/styles/components/position-proportion/position-proportion-dialog.scss'
import china from '@/assets/images/icons/bottom_icon_China.png'
import hk from '@/assets/images/icons/bottom_icon_hk.png'
import us from '@/assets/images/icons/english.png'
import viet from '@/assets/images/icons/viet.png'
import up from '@/assets/images/icons/up.png'
import down from '@/assets/images/icons/down.png'

import PositionProportionEChart from './PositionProportionEChart';
import classnames from 'classnames';
import { Converter,utilsFunction } from '@/helpers/functions'; 
import '../../../assets/styles/components/position-proportion/position-proportion-mobile.scss'


class PositionProportionDialogMobile extends Component {
    constructor(props) {
        super(props)
        this.state = {
            formData: {
              stocks: [
                { nationalIcon: hk, market: 'account_Proportion_hk', totalMarketValue: 0, detailData: [], open: true },
                { nationalIcon: china, market: 'account_Proportion_sh', totalMarketValue: 0, detailData: [], open: false  },
                { nationalIcon: china, market: 'account_Proportion_sz', totalMarketValue: 0, detailData: [], open: false  },
                { nationalIcon: us, market: 'account_Proportion_us', totalMarketValue: 0, detailData: [], open: false  },
                // { nationalIcon: viet, market: 'account_Proportion_vn', totalMarketValue: 0, detailData: [] },
              ],
              funds: [
                { nationalIcon: hk, market: 'funds_Proportion_hk', totalMarketValue: 0, detailData: [], open: true },
                { nationalIcon: china, market: 'funds_Proportion_cny', totalMarketValue: 0, detailData: [], open: false  },
                { nationalIcon: us, market: 'funds_Proportion_usd', totalMarketValue: 0, detailData: [], open: false  },
              ]
            },
            ccurrentType: 'stocks',
            actions: [
              { id: 1, key: 'common_stocks', value: 'stocks' },
              { id: 2, key: 'common_funds', value: 'funds' }
            ],
            
            marketValueDataList: null,
            stockTotalProportion: 0,
            legend: [
                {
                    // name: this.props.language.market_position_proportion_holdings,
                    selectedMode: false,
                    itemWidth: 0,
                    itemHeight: 0,
                    top: '64%',
                    left: '7%',
                    data: [{ name: this.props.language.market_position_proportion_holdings }],
                    textStyle: {
                        color: this.props.theme == 'light' ? '#000' : '#fff',
                        fontSize: 14
                    },
                    tooltip:{
                      show: true,
                    },
                },
                {   
                    type: "scroll",
                    orient: 'vertical',
                    top: '70%',
                    left: '7%',
                    // selectedMode: false,
                    pageIconColor: this.props.theme === 'light' ? "#2f4554" : '#fff',
                    pageTextStyle: {
                          color:this.props.theme === 'light' ? "#2f4554" : '#fff'
                      },
                    textStyle: {                     
                        color: this.props.theme == 'light' ? '#000' : '#fff',
                    },
                    formatter: function (name) {
                      return name.length > 50 ? name.substr(0, 50) + '\n' + name.substr(50,name.length): name
                    },
                    tooltip:{
                        show: false
                    },
                }],
            tooltip: {
                trigger: 'item',
                formatter: (params) => {
                    return (
                        // params.seriesName + '<br/>' +
                            params.marker+ params.data.sybmol+ '&nbsp;&nbsp;&nbsp;&nbsp;' + `<span style='font-weight:700'>${(utilsFunction.numericalTransformation(params.value,this.props.language))}<span>`)
                },
                position: function (point, params, dom, rect, size) {
                    return [point[0], point[1]]
                },
                confine: true,
                extraCssText: 'z-index:0'
            }
        }
        this.handleActionClick = this.handleActionClick.bind(this)
    }
    render() { 
        const { language, accessibility } = this.props
        const { formData, stockTotalProportion, marketValueDataList, legend,tooltip, actions, ccurrentType } = this.state
        return (
            <div className='position-proportion-details-mobile'>
                <div className='details-title'>
                    {actions.map((item, index) => {
                    return (<span 
                        key={item.value}
                        className={classnames('title-item', item.value === ccurrentType && 'title-item-active')}
                        onClick={() => this.handleActionClick(index)}
                        >
                        {language[item.key]}
                    </span>)
                    })}
                </div>
                <div className='details-content'>
                    <div className='details-echarts'>
                        <PositionProportionEChart
                            innerRef={e => this.PositionProportionEChartRef = e}
                            data={marketValueDataList}
                            legend={legend}
                            top={-170}
                            radius={['25%', '40%']}                       
                            tooltip={tooltip}
                            labelLine={{ show: true }}
                        ></PositionProportionEChart>
                    </div>
                    <div className='details-form'>
                        <div className='details-form-head'>
                            <div className='head-left'>
                                <span className='head-market' >{ccurrentType==="stocks"?language.common_market:language.common_currency}</span>
                                <span className='head-market-value'>{language.account_market_value}</span>
                            </div>
                            <div className='head-right'>
                                <span className='head-proportion' >{language.market_position_proportion_proportion}</span>
                            </div>
                        </div>
                        <div className='details-form-data'>
                            {formData[ccurrentType].map((item, index) => {
                                return(
                                    <div key={index}>
                                        <div className='data-single' onClick={() => this.handleDetailDataDiv(index)} >
                                            <div className='single-left'>
                                                <div className='single-left-market' ><img src={item.nationalIcon} /> {Converter.mappingMDSMarketToStock_SH(language[item.market])} </div>
                                                <span className='single-left-market-value'>{utilsFunction.numericalTransformation(item.totalMarketValue,language)}</span>
                                            </div>
                                            <div className='single-right'>
                                                <span className='single-left-proportion'>
                                                    {this.handleProportion(item.totalMarketValue, stockTotalProportion)} 
                                                    <img src={item.open ? up : down}  />
                                                </span>
                                            </div>
                                        </div>
                                        <div className={classnames('data-details', item.open ? 'open' : 'close')}>
                                            {item.detailData.map((detailsDataItem, detailsDataIndex) => {
                                                return(
                                                    <div className='data-details-item' key={detailsDataIndex}>
                                                        <div className='item-left'>
                                                            <div className='item-name'>
                                                                {detailsDataItem.name}<br/>
                                                                {detailsDataItem.stock}
                                                            </div>
                                                            <div className='item-value'>
                                                                {utilsFunction.numericalTransformation(detailsDataItem.value,language)}
                                                            </div>
                                                        </div>
                                                        <div className='item-right'>
                                                            {this.handleProportion(detailsDataItem.value, stockTotalProportion)}
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    componentDidMount() {
        this.formatData()
        this.getData()
    }

    toThousands(num) {
        return Number(num).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,' );
    }
    handleActionClick(index) {
      const ccurrentType = this.state.actions[index].value
      if (ccurrentType === this.state.ccurrentType) return
      this.setState({ ccurrentType }, () => {
        this.formatData()
        this.getData()
      })
    }

    handleProportion = (x, y) => {
        if (x != 0) {
            let res = (Number(x) / y * 100)
            return res.toFixed(2) + '%'
        } else {
            return 0+'%'
        }
    }
    handleDetailDataDiv = (index) => {
      const { formData, ccurrentType } = this.state
      formData[ccurrentType][index].open = !formData[ccurrentType][index].open
      this.setState({ formData })
    }
    formatDataCase = (index, item, stockName) => {
        const { language } = this.props
        let { formData, ccurrentType } = this.state
        let stock = ''
        let name = ''
        let value = ''
        let proportion = 0
        formData[ccurrentType][index].totalMarketValue += Number(item.marketValueClientBase)
        stock = stockName + item.stockCode
        if (language.lang === "en_US") {
            name = item.stockShortName;
        } else {
            name = item.stockChineseShortName;
        }
        value = item.marketValueClientBase
        formData[ccurrentType][index].detailData.push({ stock, name, value, proportion })
        this.setState({ formData })
        return Number(item.marketValueClientBase)
    }
    formatData = () => {
        const { portfolios } = this.props
        const { formData } = this.state
        let portfoliosList = portfolios.portfoliosList
        if (portfoliosList) {
          const newFormData = Object.keys(formData).reduce((prev, next) => {
            prev[next] = formData[next].map((v) => (v.detailData = [], v.totalMarketValue = 0, v.open = true, v))
            return prev
          }, {})
          this.setState({ formData: newFormData }, () => {
            if (this.state.ccurrentType === 'stocks') {
              let sum = 0
              portfoliosList.map((item, index) => {
                //   if (item.marketValueClientBase == 0) return
                  switch (item.marketID) {
                      case 'HKEX':
                          sum += this.formatDataCase(0, item, 'HK.')
                          break;
                      case 'MAMK':
                          sum += this.formatDataCase(1, item, 'SH.')
                          break;
                      case 'SZMK':
                          sum += this.formatDataCase(2, item, 'SZ.')
                          break;
                      case 'USEX':
                          sum += this.formatDataCase(3, item, 'US.')
                          break;
                  }
                  this.setState({ stockTotalProportion: sum })
              })
            } else if (this.state.ccurrentType === 'funds') {
              this.setState({ stockTotalProportion: portfoliosList.reduce((prev, next) => {
                if ( next.marketID === 'FUND') {
                  switch (next.currencyID) {
                    case 'HKD':
                      prev += this.formatDataCase(0, next, '')
                      break;
                    case 'CNY':
                      prev += this.formatDataCase(1, next, '')
                      break;
                    case 'USD':
                      prev += this.formatDataCase(2, next, '')
                      break;
                  }
                }
                return prev
              }, 0)})
            }
          })
        }
    }

    getData = () => {
        const { portfolios, language } = this.props;
        if (portfolios.portfoliosList) {
            let marketValueDataList = [];
            portfolios.portfoliosList.map(item => {
                let marketValueData = {};
                if (language.lang === "en_US") {
                    marketValueData.name = item.stockShortName;
                } else {
                    marketValueData.name = item.stockChineseShortName;
                }
                marketValueData.sybmol = item.marketID + '.' + item.stockCode
                marketValueData.value = item.marketValueClientBase;
                if (this.state.ccurrentType === 'stocks') {
                  const markets = ['HKEX', 'MAMK', 'SZMK', 'USEX']
                  if (markets.includes(item.marketID)) {
                    marketValueDataList.push(marketValueData);
                  }
                } else if (this.state.ccurrentType === 'funds' && item.marketID === 'FUND') {
                  const currency = ['HKD', 'CNY', 'USD']
                  if (currency.includes(item.currencyID)) {
                    marketValueDataList.push(marketValueData);
                  }
                }
            })
            this.setState({
                marketValueDataList: marketValueDataList,
            }, () => {
                if (marketValueDataList && this.PositionProportionEChartRef) {
                    this.PositionProportionEChartRef.setEChartPieData({
                        series: [{
                            data: marketValueDataList
                        }]
                    })
                }
            })
        }
    }
}
 
export default connect(
    state => ({
        language: state.app.language,
        portfolios: state.trade.portfolios,
        theme: state.app.theme
    }),
    dispatch => ({
        getPortfolioAction: (p, c) => dispatch(getPortfolioAction(p, c))
    })
)(PositionProportionDialogMobile);